export const FETCH_CUSTOMER_LIST = "FETCH_CUSTOMER_LIST";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const FETCH_CUSTOMER_NUMBER = "FETCH_CUSTOMER_NUMBER";
